<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-bottom-16">
    <h2 class="cf-title cf-title--2 cf-text-align-center">
      {{ title }}
    </h2>

    <p
      class="cf-subtitle cf-subtitle--2"
      v-html="description"
    />

    <button
      :class="['cf-button cf-button--primary cf-button--lg', { 'cf-button--loading': isProcessing }]"
      type="button"
      @click="submit"
    >
      {{ confirmCtaText }}
    </button>

    <button
      class="cf-button cf-button--secondary cf-button--lg"
      type="button"
      :disabled="isProcessing"
      @click="$closeModal('chargeHouseAccount')"
    >
      {{ cancelCtaText }}
    </button>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import dollars from '@/filters/dollars';


  export default {
    name: 'CfChargeHouseAccount',

    props: {
      total: {
        type: Number,
        required: true
      }
    },

    data() {
      return {
        isProcessing: false
      };
    },

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('session', ['currentUser', 'houseAccount']),

      houseAccountContent() {
        return (this.content && this.content.HouseAccounts) || {};
      },

      houseAccountMetadata() {
        return this.houseAccountContent.metadata || {};
      },

      title() {
        return this.houseAccountContent.title || 'Charge House Account';
      },

      description() {
        const amount = dollars(this.total);
        const name = this.currentUser.fullName || 'your house account';

        if (this.houseAccountContent.description) {
          return this.houseAccountContent.description
            .replace('{{amount}}', amount)
            .replace('{{name}}', name);
        }

        return `You are charging ${amount} to ${name}.`;
      },

      confirmCtaText() {
        return this.houseAccountMetadata.cta || 'Place Order';
      },

      cancelCtaText() {
        return this.houseAccountMetadata.secondaryCta || 'Nevermind';
      }
    },

    watch: {
      isProcessing: 'isProcessingChangeHandler'
    },

    methods: {
      isProcessingChangeHandler(isProcessing) {
        if (isProcessing) {
          this.$lockModal('chargeHouseAccount');
        }

        else {
          this.$unlockModal('chargeHouseAccount');
        }
      },

      onCheckoutError() {
        this.isProcessing = false;

        this.$closeModal('chargeHouseAccount');
      },

      onCheckoutSuccess() {
        this.$closeModal('chargeHouseAccount');
      },

      submit() {
        this.isProcessing = true;

        this.$emit('checkout', {
          contactInfo: {
            email: this.currentUser.email,
            fullName: this.currentUser.fullName,
            phoneNumber: this.currentUser.primarySmsNumber
          },
          onCheckoutError: this.onCheckoutError,
          onCheckoutSuccess: this.onCheckoutSuccess,
          paymentMethod: {
            type: 'house-account',
            houseAccountPublicId: this.houseAccount?.publicId
          }
        });
      }
    }
  };
</script>
